<script lang="ts" setup>
import { ref } from 'vue'
import useApiStore from '@browser/stores/api'
import type { DeviceFile } from '@lib/types/files'

const emit = defineEmits<(e: 'selectFiles', files: File[] | DeviceFile[]) => void>()

const {
  state: { selectDeviceFile },
} = useApiStore()

const selectFiles = (e: any) => {
  const selectedFiles = e.target.files as FileList

  emit('selectFiles', selectedFiles ? Array.from(selectedFiles) : [])
}
const input = ref<HTMLInputElement | null>(null)

const onClick = async () => {
  if (selectDeviceFile) {
    const deviceFile = await selectDeviceFile()

    emit('selectFiles', [deviceFile])
  } else {
    input.value?.click()
  }
}

defineExpose({
  onClick,
})
</script>

<template>
  <input ref="input" class="hidden" multiple type="file" @change="selectFiles" />
</template>
